export const issn = '67';
export const token_type = 'moss-token';
export const url_dev = 'http://172.30.1.101:9000';
export const url_production = 'https://api-moss.17m3.com';